import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class EventWaitlistService {
  fetchEventWaitlist = params => {
    return fetch(config.config.endpointUrls.fetchEventWaitlist(params), {
      method: 'GET'
    })
  }

  addToEventWaitlist = params => {
    return fetch(config.config.endpointUrls.addToEventWaitlist(), {
      method: 'POST',
      body: params
    })
  }

  deleteFromEventWaitlist = id => {
    return fetch(config.config.endpointUrls.deleteFromEventWaitlist(id), {
      method: 'DELETE'
    })
  }

  addToCustomerEventWaitlist = ({ eventIds, customerId, storeId, replace }) => {
    return fetch(config.config.endpointUrls.addToCustomerEventWaitlist({ customerId, storeId, replace }), {
      method: 'POST',
      body: eventIds
    })
  }
}

export default new EventWaitlistService()



// WEBPACK FOOTER //
// ../src/services/eventWaitlistService/eventWaitlistService.js